export default __webpack_public_path__ + "static/media/Number_2_dark.71bda115.svg";